var Helpers_MC = {
	hiddenField: function( name, value ) {
		return '<input id="' + name + '" type="hidden" name="attributes[' + name + ']" value="' + value + '">';
	}
};
var Append_General_Variable_Fields_MC = {
	init: function() {
		// Cookies.remove('document-referrer');
		this.saveData();
		this.appendDataToCartForm();
	},
	appendDataToCartForm: function() {
		if ( jQuery('body').hasClass('template-cart') ) {
			var productForm = jQuery('form#cart-form');
			productForm.prepend( Helpers_MC.hiddenField( 'document-referrer', Cookies.get('document-referrer') ) );
		}
	},
	saveData: function() {
		if ( ! Cookies.get('document-referrer') || Cookies.get('document-referrer') == 'empty' ) {
			if ( document.referrer == '' ) {
				Cookies.set( 'document-referrer', 'empty' );
			} else {
				Cookies.set( 'document-referrer', document.referrer );
			}
		}
	}
};
var Append_UTM_Variable_Fields_MC = {
	/*
	http://codingleader.com/products/carrier-contract-negotiation-tactics?preview_theme_id=106479175&utm_source=test-source&utm_medium=test-medium&utm_campaign=test-campaign&utm_term=test-term&utm_content=test-content
	utm_source = seed_list&
	utm_medium = SEEDLISTSOURCE&
	utm_campaign = NMC5+%232+EW231611&
	*/
	init: function() {

		// this.showData('page start');

		this.saveUtmData();
		this.showSavedData();
		this.removeSavedData();
		this.appendUtmDataToCartForm();
	},
	appendUtmDataToCartForm: function() {
		if ( jQuery('body').hasClass('template-cart') ) {

			// this.showData('appendUtmData');

			var productForm = jQuery('form#cart-form');
			if ( Cookies.get('utm_source_') ) {
				productForm.prepend( Helpers_MC.hiddenField( 'utm_source', Cookies.get('utm_source_') ) );
			} else {
				productForm.prepend( Helpers_MC.hiddenField( 'utm_source', 'empty' ) );
			}
			if ( Cookies.get('utm_medium_') ) {
				productForm.prepend( Helpers_MC.hiddenField( 'utm_medium', Cookies.get('utm_medium_') ) );
			} else {
				productForm.prepend( Helpers_MC.hiddenField( 'utm_medium', 'empty' ) );
			}
			if ( Cookies.get('utm_campaign_') ) {
				productForm.prepend( Helpers_MC.hiddenField( 'utm_campaign', Cookies.get('utm_campaign_') ) );
			} else {
				productForm.prepend( Helpers_MC.hiddenField( 'utm_campaign', 'empty' ) );
			}
			if ( Cookies.get('utm_term_') ) {
				productForm.prepend( Helpers_MC.hiddenField( 'utm_term', Cookies.get('utm_term_') ) );
			} else {
				productForm.prepend( Helpers_MC.hiddenField( 'utm_term', 'empty' ) );
			}
			if ( Cookies.get('utm_content_') ) {
				productForm.prepend( Helpers_MC.hiddenField( 'utm_content', Cookies.get('utm_content_') ) );
			} else {
				productForm.prepend( Helpers_MC.hiddenField( 'utm_content', 'empty' ) );
			}
		}
	},
	saveUtmData: function() {
		if ( location.search.indexOf('utm') > -1 ) {
			var urlVars = this.getUrlVars();

			if ( typeof urlVars.utm_source != 'undefined' ) {
				Cookies.set( 'utm_source_', urlVars.utm_source );
			} else {
				Cookies.set( 'utm_source_', 'empty' );
			}
			if ( typeof urlVars.utm_medium != 'undefined' ) {
				Cookies.set( 'utm_medium_', urlVars.utm_medium );
			} else {
				Cookies.set( 'utm_medium_', 'empty' );
			}
			if ( typeof urlVars.utm_campaign != 'undefined' ) {
				Cookies.set( 'utm_campaign_', urlVars.utm_campaign );
			} else {
				Cookies.set( 'utm_campaign_', 'empty' );
			}
			if ( typeof urlVars.utm_term != 'undefined' ) {
				Cookies.set( 'utm_term_', urlVars.utm_term );
			} else {
				Cookies.set( 'utm_term_', 'empty' );
			}
			if ( typeof urlVars.utm_content != 'undefined' ) {
				Cookies.set( 'utm_content_', urlVars.utm_content );
			} else {
				Cookies.set( 'utm_content_', 'empty' );
			}
			// this.showData('saveUtmData');
		}
	},
	showData: function(note) {
		/*alert(
			note
			+ ': utm_source=' + Cookies.get('utm_source_')
			+ ' utm_medium=' + Cookies.get('utm_medium_')
			+ ' utm_campaign=' + Cookies.get('utm_campaign_')
			+ ' utm_term=' + Cookies.get('utm_term_')
			+ ' utm_content=' + Cookies.get('utm_content_')
		);*/
		console.log(Cookies.get());
	},
	showSavedData: function() {
		if ( location.search === '?show_saved_data' ) {
			// this.showData('show_saved_data');
		}
	},
	removeSavedData: function() {
		if ( location.search === '?remove_saved_data' ) {
			Cookies.remove('utm_source_');
			Cookies.remove('utm_medium_');
			Cookies.remove('utm_campaign_');
			Cookies.remove('utm_term_');
			Cookies.remove('utm_content_');
			// this.showData('remove_saved_data');
		}
	},
	getUrlVars: function() {
		var vars = [],
			hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
};
jQuery(document).ready(function() {
	Append_UTM_Variable_Fields_MC.init();
	Append_General_Variable_Fields_MC.init();
});
